import api from "./axiosInstance";

/**
 * User API Service
 * Handles all user related API calls
 */

export const userApi = {
  /**
   * Get all users
   * GET /api/v1/settings/users/getAllUsers
   */
  getAllUsers: (params) => {
    return api.get("settings/users/getAllUsers", { params });
  },

  /**
   * Get user by ID
   * GET /api/v1/settings/users/getById/{id}
   */
  getUserById: (id) => {
    return api.get(`settings/users/getById/${id}`);
  },

  /**
   * Create user
   * POST /api/v1/settings/users/create
   */
  createUser: (data) => {
    return api.post("settings/users/create", data);
  },

  /**
   * Update user
   * PUT /api/v1/settings/users/update/{id}
   */
  updateUser: (id, data) => {
    return api.put(`settings/users/update/${id}`, data);
  },

  /**
   * Delete user
   * DELETE /api/v1/settings/users/delete/{id}
   */
  deleteUser: (id) => {
    return api.delete(`settings/users/delete/${id}`);
  },

  /**
   * Toggle user status
   * PUT /api/v1/settings/users/{username}/status
   */
  toggleUserStatus: (username, active) => {
    return api.put(`${username}/status`, null, {
      params: { active }
    });
  }
};

export default userApi;
